import React, { useEffect } from "react";

// import CSS
import "./App.css";

import { Route, Switch, Redirect } from "react-router-dom";

import PhysicianLogin from "./pages/Login/PhysicianLogin";

// import components
import HomePage from "./pages/HomePage/HomePage";
import ResetPasswordComponent from "./components/ResetPasswordComponent/ResetPasswordComponent";
import VerificationOTP from "./pages/Login/PhysicianLogin/components/VerificationOTP";
import { useVersionUpdater } from './hooks/useVersionUpdater';
import { AuthenticatedSessionProvider, useAuthentication } from "./context/AuthProvider";
import config from "./config";

function App() {
  const { accessToken, impersonateUser } = useAuthentication();

  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.origin.startsWith(config.adminClientUrl)) {
        console.warn('message received from invalid origin', event.origin);
        return;
      }

      const data = event.data;
      
      if (data.action === 'start') {
        impersonateUser({
          refreshToken: {
            value: data.payload.refreshToken,
            expiresAt: data.payload.sessionExpiresAt,
            locksAt: data.payload.sessionLocksAt,
          },
          accessToken: data.payload.accessToken
        })
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useVersionUpdater();

  return (
    <div className="App">
      <Switch>
        <Route
        path="/verify-otp/:userId"
        render={(props)=><VerificationOTP {...props}/>}
        />
        <Route path="/dashboard" render={(props) => {
          if (accessToken) {
            return (
              <AuthenticatedSessionProvider>
                <HomePage {...props} />
              </AuthenticatedSessionProvider>
            )
          }
          return <Redirect to='/login' {...props} />;
        }} />
        <Route
          path="/login"
          render={(props) => {
            if (accessToken) return <Redirect to='/dashboard' {...props} />;
            return <PhysicianLogin {...props} />;
          }}
        />
        
        <Route
          path="/reset-password"
          render={(props) => <ResetPasswordComponent {...props} />}
        />

        
        <Route
          exact
          path="/*"
          render={(props) => {
            if (accessToken) return <Redirect to='/dashboard' {...props} />;
            return <Redirect to='/login' {...props} />;
          }}
        />
      </Switch>
    </div>
  );
}

export default App;
